<div class="row accordion">
  <div class="col-md-8 col-sm-9 accordion__cursor">
    <sc-title type="h3" [content]="title" (click)="onClickOpen()"></sc-title>
  </div>
  <div class="col-md-4 col-sm-3 text-right">
    <sc-edit-button
      *ngIf="canEdit"
      class="accordion__edit-button"
      [loading]="editLoading"
      [disabled]="editValidation?.canStart === false"
      [disabledMessage]="editValidation?.message"
      [tooltipText]="tooltipText"
      (click)="handleEditClicked()"></sc-edit-button>
    <sc-icon class="accordion__toggler" [class.accordion__toggler--open]="isOpen" icon="arrow-down" (click)="onClickOpen()"></sc-icon>
  </div>
  <div class="col-md-12 pl-0 pr-0" [@slideFade]="isOpen ? 'in' : 'out'">
    <ng-content>
    </ng-content>
  </div>
</div>